import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import CompetitorsCustomerGrowth from '../components/CompetitorsCustomerGrowth'

export default function TurningYourCompetitorsCustomersIntoYourGrowthEngine() {
  return (
    <div>
      <Header1/>
      <CompetitorsCustomerGrowth/>
      <Footer/>
    </div>
  )
}
